export default [
  {
    key: 'cr',
    name: '点击率',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect'
  },
  {
    key: 'cc',
    name: '点击单价(元)',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect'
  },
  {
    key: 'cpm',
    name: '千次展现消费(元)',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect',
    minWidth: 180
  },
  {
    key: 'list_ctr',
    name: '列表页CTR',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect'
  },
  {
    key: 'detail_ctr',
    name: '内容页CTR',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect'
  },
  {
    key: 'list_acp',
    name: '列表页ACP',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect'
  },
  {
    key: 'detail_acp',
    name: '内容页ACP',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect'
  },
  {
    key: 'list_ecpm',
    name: '列表页ECPM',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect'
  },
  {
    key: 'detail_ecpm',
    name: '详情页ECPM',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'good_effect'
  }
];
